import * as z from 'zod/v4';

export const scoreSchema = z
  .object({
    home: z.number(),
    away: z.number(),
  })
  .transform<[number, number]>(({ home, away }) => {
    return [home, away];
  });
